/* eslint-disable class-methods-use-this */
import CryptoJS from "react-native-crypto-js";
import {S3Client } from "@aws-sdk/client-s3";
import  upperFirst  from "lodash/upperFirst";
import config from "../config/config";
import TAX_RATE_LIST from "../constant/rateList";
import {
  IAddress1,
  ImageDimData,
  IPredictionsResponse,
  ISheetPriceData,
  ISheetWeightDataRes,
  ItemWithDimension,
  SheetInfoRes,
} from "../interfaces/commonInterface";

import { getPlacesDetail, getPredictions } from "../services/google";
import { EditOrderData, ItempImages, UserOderList } from "../interfaces/orderInterface";
import {  DISCOUNT_PER,DISCOUNT_PERCENTAGE_TIER3,MEMBERSHIP_PLANS_TYPE,PNG,PNG_FLAG,STATUS_ORDER } from "../constant/commonConstants";
import { IArtWorkDataSubmit } from "../interfaces/artworkInterface";
import { getMultipleSignedUrl, getSignedUrl } from "../services/user";
import { ISheetInfoParams } from "../store/commonStore";

const BucketURL = process.env.REACT_APP_BUCKET_BASE_URL;

class Helper {
  /**
   *
   * Method to capitalize a string's first character
   * @param string string
   * @returns The capitalized string
   */
  capitalize = (string: string) =>
    string?.toLowerCase()?.replace(/\b[a-z]/g, (letter) => letter?.toUpperCase());

  changeNumberFormate = (string: string) => {
    if (string && string?.length) {
      return `+1 (${string?.substring(0, 3)}) ${string?.substring(
        3,
        6
      )}-${string?.substring(6, string.length)}`;
    }
    return null;
  };

  sheetNameHandler=(args:string)=>{
    const fileName=args?.split("_")[0];
    if(fileName){
      return fileName;
    }
    return args;
  };

  getSheetName = (
    orderId: number,
    imageIndex: number,
    orderLength: number,
    quantity: number,
    sheetName: string,
    totalSheets?: number,
    clientName?: string,
    companyName?: string,
    sheetDimension?: string
  ): string => {
    sheetName=this.sheetNameHandler(sheetName);
    sheetDimension=sheetDimension?.replaceAll("in.","")?.replaceAll(" ","");
    return `${orderId}-${imageIndex}-${orderLength}-${quantity}-${totalSheets}-
    ${clientName?.replaceAll(/\s+/g, "_")?.replaceAll("-","_")}-
    ${companyName===null||companyName===undefined ?"Null"
      :this?.capitalizeCompanyName(companyName?.replaceAll(/\s+/g, "_")?.replaceAll("-","_"))}-
    ${sheetDimension?sheetDimension:""}-
    ${sheetName?.replaceAll(/\s+/g, "_")?.replaceAll("-","_")?.replaceAll("_*_","-")?.replace(",png","")?.replace(",pdf","")}`
      ?.replace(/\s+/g, "")
      ?.replace("--", "");
  };

  /**
   * Fetch address predictions based on searched text
   * @param searchText
   * @returns predictions
   */

  fetchPredictions = async (
    searchText: string
  ): Promise<IPredictionsResponse> =>
    new Promise((resolve, reject) => {
      try {
        (async () => {
          const response = await getPredictions(searchText);
          resolve(response?.data as IPredictionsResponse);
        })();
      } catch (e) {
        reject(e);
      }
    });

  /**
   * Fetches complete address info based on specified place id
   * @param place_id place id
   * @returns address object
   */

  onPlaceSelected = async (place_id: string) => {
    const response = await getPlacesDetail(place_id);
    let address: IAddress1 = {};
    if (response.data && response.data?.success) {
      address = { ...response.data.data };
    }
    return address;
  };

  discountHandler = (currTier: string,maxTier: string,basePrice: number,quantity: number) => {
    let result = 0;
    if (currTier !== maxTier) {
      const disPrice = +((DISCOUNT_PER * basePrice) / 100).toFixed(2);
      const newBasePriceForAdvanceMember = Number(
        (basePrice - disPrice).toFixed(2)
      );
      result =
        Number((basePrice - newBasePriceForAdvanceMember).toFixed(2)) *
        quantity;
    }
    if (currTier === maxTier) {
      const disPrice = +((DISCOUNT_PERCENTAGE_TIER3 * basePrice) / 100).toFixed(2);
      const newBasePriceForAdvanceMember = Number((basePrice - disPrice).toFixed(2));
      result =
        Number((basePrice - newBasePriceForAdvanceMember).toFixed(2)) *
        quantity;
    }
    return result;
  };

  matchTier = (
    sheetPriceData: ISheetPriceData[],
    currArea: number
  ): ISheetPriceData => {
    for (const i in sheetPriceData) {
      if (currArea > 0 && currArea <= sheetPriceData[i].tier_area) {
        return sheetPriceData[i];
      }
    }
    return sheetPriceData[sheetPriceData.length - 1];
  };


  getItemDiscountPrice = (
    quantity: number,
    dimensions: string,
    membershipPlan: string,
    sheetPriceData: ISheetPriceData[],
    totalSheetArea=0,
  ) => {
    let price = 0;
    if (dimensions.length === 0) {
      return price;
    };
    const matchTierRange = this.matchTier(sheetPriceData, totalSheetArea);
    // console.log("matchTierRange",matchTierRange?.tier_title);
    if(membershipPlan &&matchTierRange && matchTierRange.per_square_fit_price>0){
      if(MEMBERSHIP_PLANS_TYPE[1].value===membershipPlan) {
        //  ADVANCE MEMBER WISE DISCOUNT
          const basePrice= Number(
            +(sheetPriceData[0].per_square_fit_price * this.oneUnitArea(dimensions)).toFixed(2)
          );
          price = this.discountHandler(matchTierRange.tier_title,
            sheetPriceData[sheetPriceData.length - 1].tier_title,basePrice,quantity
          );
      } else {
        // TIER WISE DISCOUNT
          const basePrice = Number(
            (sheetPriceData[0].per_square_fit_price * this.oneUnitArea(dimensions)).toFixed(2));
          const tierWisePrice = Number(
              (matchTierRange.per_square_fit_price * this.oneUnitArea(dimensions)).toFixed(2));
          price = Number((basePrice-tierWisePrice).toFixed(2))*quantity; 
      }
     };
    return price;
  };


  s3ClientHelper=()=>{
    const s3Client = new S3Client({
      region: process.env.REACT_APP_AWS_REGION as string,
      useAccelerateEndpoint: true,
    });
    return s3Client;
  }

  // table dim

  getTableDimenssion = (
    dim: string,
    planType: string,
    sheetData: ISheetInfoParams[]
  ) => {
    let dimenssion = "";
    const tempDim = dim?.split(" ");
    sheetData.forEach((item: ISheetInfoParams) => {
      if (
        +tempDim[0] === item.length &&
        +tempDim[3] === item.width &&
        item.membership_type.toLowerCase().includes(planType)
      ) {
        dimenssion = `${item.length} in. x ${item.width} in.`;
      }
    });

    return dimenssion;
  };

  getEncryptId = (userId: number) => {
    let id = "";

    const encData = CryptoJS.AES.encrypt(
      JSON.stringify(userId),
      config.userId_encryption_key as string
    ).toString();
    id = encData.replace(/\//g, "@@@");
    return id;
  };

  /**
   * Function to calculate the status of order
   */
  calculateOrderStatus = (products: UserOderList[]) => {
    if(!products || products?.length===0) return STATUS_ORDER.PENDING;
    const counts=new Map();    
    for(const key of Object.values(STATUS_ORDER)){
      if(!counts.has(key)){
        counts.set(key,0);
      }
    };

    for(const {image_status} of products){
      if(counts.has(image_status)){
        counts.set(image_status,counts.get(image_status)+1);
      }
    };

    const statuses = [
      { status: STATUS_ORDER.PAYMENT_PENDING, condition: counts.get(STATUS_ORDER.PAYMENT_PENDING) > 0 },
      { status: STATUS_ORDER.ON_HOLD, condition: counts.get(STATUS_ORDER.ON_HOLD) > 0 },
      { status: STATUS_ORDER.PROCESSING, condition: counts.get(STATUS_ORDER.PROCESSING) > 0 },
      { status: STATUS_ORDER.PENDING, condition: counts.get(STATUS_ORDER.PENDING) > 0 },
      { status: STATUS_ORDER.COMPLETED_PENDING, condition: counts.get(STATUS_ORDER.COMPLETED_PENDING) > 0 },

      { status: STATUS_ORDER.COMPLETED_PENDING, condition: counts.get(STATUS_ORDER.COMPLETED_PENDING) === products.length },
      { status: STATUS_ORDER.APPROVE, condition: counts.get(STATUS_ORDER.APPROVE) === products.length },
      { status: STATUS_ORDER.COMPLETED, condition: counts.get(STATUS_ORDER.COMPLETED) === products.length },
      { status: STATUS_ORDER.CANCELLED, condition: counts.get(STATUS_ORDER.CANCELLED) === products.length },

      { status: STATUS_ORDER.APPROVE, condition: counts.get(STATUS_ORDER.APPROVE)>0 },

      // PARTIAL COMPLETED CONDITION
      {
        status: STATUS_ORDER.COMPLETED,
        condition:
          counts.get(STATUS_ORDER.COMPLETED) > 0 &&
          counts.get(STATUS_ORDER.COMPLETED) < products.length &&
          counts.get(STATUS_ORDER.PAYMENT_PENDING) === 0 &&
          counts.get(STATUS_ORDER.ON_HOLD) === 0 &&
          counts.get(STATUS_ORDER.PROCESSING) === 0 &&
          counts.get(STATUS_ORDER.PENDING) === 0 &&
          counts.get(STATUS_ORDER.COMPLETED_PENDING) === 0 &&
          counts.get(STATUS_ORDER.APPROVE) === 0,
      },
    ];
    
    for (const { status, condition } of statuses) {
      if (condition) {
        return status;
      }
    }
    return STATUS_ORDER.PENDING;     
  };

   memoize = (fn:(dim:string)=>number) => {
      const cache = new Map();
      return (key:string):number => {
      if (cache.has(key)) {
        return cache.get(key);
      }
      const result = fn(key);
      cache.set(key, result);
      return result;
    }
 };

  oneUnitArea=this.memoize((dim)=>{
    let area=0;
    if(dim  && dim!==""){
      const dimension= dim.split(" ");
      if(dimension && dimension.length>=4){
        area =(Number(dimension[0]) * Number(dimension[3])) /144;
      }
    };
    return area;
  });

  getsheetPriceByDimension=(baseTierData:ISheetPriceData,
     currDim:string,
    ) =>{
    let sheetBasePrice=0;
    if(baseTierData && currDim){
      sheetBasePrice = Number((
        this.oneUnitArea(currDim) *
        baseTierData.per_square_fit_price
      )?.toFixed(2));
    }
    return sheetBasePrice;
  };

  groupByData = <T extends (ItempImages | IArtWorkDataSubmit | EditOrderData) & ItemWithDimension>(
    arr: T[],
    from: keyof ItemWithDimension
  ): T[] => {
    const groupedData: { [key: string]: T } = {};
    arr.forEach(item => {
      if (Object.prototype.hasOwnProperty.call(item, from)) {
        const key = item[from];
        if(key){
          if (groupedData[key]) {
            groupedData[key].quantity = +groupedData[key].quantity + Number(item.quantity);
          } else {groupedData[key] = { ...item }};
        }
      }
    });
    return Object.values(groupedData).filter(item => Number(item.quantity) > 0);
  };
  
  calculateTotalArea = <T extends (ItempImages | IArtWorkDataSubmit | EditOrderData) & ItemWithDimension>(
    arr: T[],
    from: keyof ItemWithDimension
  ): number => {
    let totalArea=0;
    if(arr && arr.length>0){
      arr.forEach((item)=>{
        if(Object.prototype.hasOwnProperty.call(item, from)){
          const key = item[from];
          if(key){ totalArea += this.oneUnitArea(key) * item.quantity}
        }
      });
    };
    return Math.ceil(totalArea);
  };

  capitalizeCompanyName=(param?:string)=>{
   if(param){
    param=param.split("_").map(char=>upperFirst(char)).join("_")
   };
   return param;
  };

  profileImageHandler=(url:string):string=>{
    if(BucketURL && url && url?.startsWith(BucketURL?.split(".")[0])){
      return url;
    }
    return `${BucketURL}${url}`;
  }

  sanitizePath = (path?: string): string => {
    return path?.replace(/[%,*]/g, "").replace(/\s+/g, "").substring(0, 43) || "";
  };

  checkWeight(info: ISheetWeightDataRes[], sheet: SheetInfoRes) {
    let weight = 0;
    for(const item of info){
      if (
        +item.size.split(" ")[0] === sheet.length &&
        +item.size.split(" ")[3] === sheet.width
      )
      weight = item.sheet_weight;
    }
    return weight;
  }

  calculateTotalPrice = (arg: {
    subTotal: number;
    membershipPrice: number;
    priceErrorCount: number;
    totalSheet: number;
    shippingPrice: number;
    tax: number;
  }) => {
    let total = 0;
    if (arg && Object.values(arg).length > 0) {
      total = (arg.subTotal || 0) + (arg.shippingPrice || 0) + (arg.tax || 0) - (arg.membershipPrice || 0);
    }
    return total;
  };

  fetchImage = async (imageUrl: string) => {
    try {
      const response = await fetch(imageUrl, {
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Access-Control-Allow-Headers": "X-PINGOTHER, Content-Type",
          "x-amz-acl": "public-read",
          "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
          "Content-Type": "image/pdf",
        },
      });
      return response.blob();
    } catch (err) {
      console.error(`Error fetching image ${imageUrl}:`, err);
      throw err;
    }
  };


  handleFileUrl=(url:string)=>{
    const isPNG = url?.includes(PNG_FLAG);
    const fileType = isPNG ? "%2Cpng" : "%2Cpdf";
    const defaultImage =url?.split("/")[4];

    const imageName = url?.includes(fileType) && url?.includes("_*_")
      ? url?.split("_*_")[1]?.replace(fileType, "")
      : defaultImage || (url?.lastIndexOf("/") !== -1 && url?.lastIndexOf(".") !== -1
        ? url.substring(url.lastIndexOf("/") + 1, url.lastIndexOf("."))
        : "");
    return imageName?.replaceAll("%20","");
  };

  /**
   *  Download the sheet/image
   */
  download = async (url: string, name: string) => {
    if (!url) {
      throw new Error("Resource URL not provided! You need to provide one");
    }

    try {
      const response = await fetch(url, {
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Access-Control-Allow-Headers": "X-PINGOTHER, Content-Type",
          "x-amz-acl": "public-read",
          "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
          "Content-Type": "image/pdf",
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch resource: ${response.statusText}`);
      }

      const blob = await response.blob();
      const blobURL = URL.createObjectURL(blob);

      const anchor = document.createElement("a");
      anchor.href = blobURL;
      anchor.style.display = "none";
      if (name && name.length) {
        anchor.download = name;
      }

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("Error downloading resource:", error);
    }
  };

  handleDownload = (
    order: {
      image: string;
      orderId: number;
      quantity: number;
      dimension: string;
      index: number,
      productListLength: number,
    },
    userInfo: {
      totalSheet: number,
      firstName: string;
      lastName: string;
      companyName: string;
    }
  ) => {
    if(!order || !userInfo) return;
    const sheetName = this.getSheetName(
      order.orderId,
      order.index + 1,
      order.productListLength,
      order.quantity,
      this.handleFileUrl(order.image),
      userInfo.totalSheet,
      `${upperFirst(userInfo.firstName)}_${upperFirst(userInfo.lastName)}`,
      userInfo.companyName,
      order.dimension
    );
    this.download(order.image, sheetName);
  };

  pushFileToS3 = async (signedUrl: string, file: Blob) => {
    if(!signedUrl || !file)return;
    const myHeaders = new Headers({
      "Content-Type": file.type,
    });
    try {
      const response = await fetch(signedUrl, {
        method: "PUT",
        headers: myHeaders,
        body: file,
      });
      if (!response.ok) {
        throw new Error(`Failed to upload file: ${response.status} ${response.statusText}`);
      }
      return response;
    } catch (error) {
      throw new Error(`Error uploading file: ${error}`);
    }
  };

  uploadSingleFile = async (file: File, filePath: string,from:"PROFILE"|"ONHOLD",userId?:number) => {
    if(!file||file===undefined) return;
    const fileNameArr = file?.name?.split(".");
    const fileExt = fileNameArr?.pop();
    const fileNameWithoutExt = fileNameArr;
    if(from==="ONHOLD" && userId){
      filePath=`images/${fileNameWithoutExt[0]}_${userId}_${new Date().getTime()}.${fileExt}`;
    };

    let signedUrl;
    // CALL BACKEND  FOR GENERATE URLS 
    const {data} = await getSignedUrl({
      filePath,
      fileFormat: file.type as string,
    });
  
    if (data && data.success && data.data) {
      const response = await this.pushFileToS3(data?.data, file);
      if (response?.url) {
        signedUrl = response?.url?.split("?")?.[0];
      }
    };
    return signedUrl;
  };

  uploadMultipleFiles = async (fileList:File[],userId:number) => {
    if (!fileList || fileList.length === 0) return;
  
    const payload = fileList.map((file) => {
      const fileNameArr = file?.name?.split(".");
      const fileExt = fileNameArr?.pop();
      const fileNameWithoutExt = fileNameArr;
       return{
        filePath:`images/${fileNameWithoutExt[0]}_${userId}_${new Date().getTime()}.${fileExt}`,
        fileFormat:file.type 
       }
    })

    const {data}=await getMultipleSignedUrl(payload);
    if(data?.success){
     return  Promise.all(
       Array.from(fileList).map(async(file,index)=>{
         const response = await this.pushFileToS3(data.data[index].url, file);
         if (response?.url) {
           const url=response?.url?.split("?")?.[0];
           return{
            image:url,
            image_resize:url.includes(PNG)?url.replace("images","compressed"):url,
            image_size:file.size, 
            filePath:data.data[index].url,
            fileType:file.type,
            fileName:file.name,
            item_index:index+1,
            userId
           }
         }
       })
     )};
  };


  getfileName=(imageUrl:string)=>{
    return imageUrl.substring(imageUrl.lastIndexOf("/") + 1, imageUrl.length).split(".")[0]
  };

  getHeightAndWidth=(src:string)=> {
      return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = () => resolve(img);
          img.onerror = reject;
      });
  };

  getDimension = (fileInfo: string[],sheetInfoData:SheetInfoRes[],membershipPlan:string) => {
      if (fileInfo[0].slice(0, 3).toLowerCase() === "qty") return undefined;
      const temp: ImageDimData[] = [];
      sheetInfoData.forEach((sheet: SheetInfoRes) => {
      if (
      ((+fileInfo[0].split("x")[0] === sheet.length && +fileInfo[0].split("x")[1] === sheet.width) ||
      (+fileInfo[0].split("x")[0] === sheet.width && +fileInfo[0].split("x")[1] === sheet.length)) &&
      sheet.membership_type.toLowerCase().includes(membershipPlan)
      ) {
        temp.push({
        name: `${sheet.length} in. x ${sheet.width} in.`,
        value: `${sheet.length}"${sheet.width}"`,
        });
      }
      });
      return temp.length > 0 ? temp[0].name : undefined;
    };
    

  intervalTime = (length: number): number => {
      const thresholds = [
        { max: 5, value: 60 },
        { max: 10, value: 250 },
        { max: 15, value: 350 },
        { max: 20, value: 450 },
        { max: 25, value: 700 },
        { max: 30, value: 1000 },
      ];
      for (const { max, value } of thresholds) {
        if (length < max) return value;
      }
      return 1000;
  }

  dimesionCountHandler=(arr:{image_dimension:string,imageDimenssion:string, quantity:number, image_status?:string}[]):{
    name: string;
    value: number;
  }[]=>{
    if(!arr || !arr.length) return [];
    const obj:{[key:string]:number}={};
    for(const item of arr){
      if(item.image_status!==STATUS_ORDER.CANCELLED){
        const key=item.image_dimension||item["imageDimenssion"];
        if(key && key!==""){
          obj[key]=(obj[key]||0)+(item.quantity||0);
        }else{
            obj[key]=0;
        }
      };
    }
    return Object.keys(obj).map((key)=>({name:key,value:obj[key]}));
  };
 
  /**
   * Function to calculate tax based on subtotal, zip code, discount and tax exemption status
   * @param subTotal - The subtotal amount
   * @param zipCode - The zip code for tax rate lookup
   * @param discount - The discount amount to be applied
   * @param taxExempt - Boolean indicating if the user is tax exempt
   * @returns Calculated tax amount
   */
  taxCalculation=({subTotal,zipCode,discount,taxExempt}:
    {subTotal:number;zipCode:string,discount:number,taxExempt:number})=>{
    if(!subTotal || !zipCode ||taxExempt) return 0;
    const taxRate= TAX_RATE_LIST.get(Number(zipCode))?.EstimatedCombinedRate;
    if(taxRate && taxRate>0){
      subTotal=subTotal-discount||0;
      return +(subTotal*taxRate).toFixed(2)
    };
    return 0;
  }
};

export default new Helper();
